import { Outlet } from "react-router-dom";
import AdminLayout from "../../components/Admin/Layout/AdminLayout";
import { useAuthStore } from "../../store";

function Admin() {

  //////////////////////////////////////////////////////////////

  const { isLoggedIn } = useAuthStore();

  //////////////////////////////////////////////////////////////

  return (
    <>
      {isLoggedIn ? (
        // 로그인된 사용자는 Layout과 함께 Outlet을 렌더링
        <AdminLayout />
      ) : (
        // 로그인되지 않은 사용자는 Layout 없이 Outlet만 렌더링
        <Outlet />
      )}
    </>
  );
}

export default Admin;
